export function getQueryParam (url, paramName) {
  const queryStart = url.indexOf('?')
  if (queryStart === -1) {
    return null
  }

  const queryString = url.substring(queryStart + 1)
  const params = queryString.split('&')

  for (const param of params) {
    const equalIndex = param.indexOf('=')
    if (equalIndex === -1) {
      continue
    }

    const key = param.substring(0, equalIndex)
    const value = param.substring(equalIndex + 1)

    if (key === paramName) {
      return value
    }
  }

  return null
}
